(() => {
  function readMeasurement(cell, header) {
    const text = cell.textContent.trim().toLowerCase();
    const inches = text.match(/(\d+(?:\.\d+)?)\s*(?:in(?:ches)?\b|["″])/);
    if (inches) return Number(inches[1]);
    const cm = text.match(/(\d+(?:\.\d+)?)\s*cm\b/);
    if (cm) return Number(cm[1]) / 2.54;
    if (/^\d+(?:\.\d+)?$/.test(text)) {
      if (/\b(?:in|inch|inches)\b|["″]/.test(header)) return Number(text);
      if (/\bcm\b/.test(header)) return Number(text) / 2.54;
    }
    return null;
  }

  function readChart(body) {
    const tables = body.querySelectorAll('table');
    if (tables.length !== 1) return null;
    const rows = [...tables[0].rows];
    if (rows.length < 2) return null;
    const headers = [...rows[0].cells].map(cell => cell.textContent.trim().toLowerCase());
    if (headers.length !== 3) return null;
    const sizeIndex = headers.findIndex(text => /^size\b/.test(text));
    const lengthIndex = headers.findIndex(text => /\blength\b/.test(text));
    const chestIndex = headers.findIndex(text => /^(?:bust|chest)(?:\s|$|\()/.test(text) && !/body|width|half/.test(text));
    if ([sizeIndex, lengthIndex, chestIndex].some(index => index < 0)) return null;
    const sizes = rows.slice(1).map(row => {
      if (row.cells.length !== headers.length) return null;
      const chest = readMeasurement(row.cells[chestIndex], headers[chestIndex]);
      const length = readMeasurement(row.cells[lengthIndex], headers[lengthIndex]);
      const size = row.cells[sizeIndex].textContent.trim();
      if (!size || !chest || !length || chest < 28 || chest > 90 || length < 15 || length > 50) return null;
      return { size, chest, length, width: chest / 2 };
    });
    if (sizes.some(size => !size)) return null;
    return sizes;
  }

  function enhance(body, template) {
    if (!body || !template) return;
    const sizes = readChart(body);
    if (!sizes) return;
    const fragment = template.content.cloneNode(true);
    const guide = fragment.querySelector('.fxg-size-guide');
    const copy = JSON.parse(guide.querySelector('[data-size-guide-copy]').textContent);
    const oldTable = body.querySelector('table');
    const table = document.createElement('table');
    const caption = table.createCaption();
    caption.className = 'visually-hidden';
    caption.textContent = copy.caption;
    const header = table.createTHead().insertRow();
    ['size', 'width', 'length', 'chest'].forEach(key => {
      const cell = document.createElement('th');
      cell.scope = 'col';
      cell.dataset.measureHeading = key;
      header.append(cell);
    });
    const tbody = table.createTBody();
    sizes.forEach(size => {
      const row = tbody.insertRow();
      const label = document.createElement('th');
      label.scope = 'row';
      label.textContent = size.size;
      row.append(label);
      ['width', 'length', 'chest'].forEach(key => row.insertCell().dataset.measure = key);
    });
    guide.querySelector('[data-size-table]').append(table);
    oldTable.replaceWith(fragment);
    let unit = 'in';
    let matchedSize = null;
    const input = guide.querySelector('[data-shirt-width]');
    const result = guide.querySelector('[data-size-result]');
    const format = value => Number((value * (unit === 'cm' ? 2.54 : 1)).toFixed(1)).toString();

    function renderTable() {
      header.querySelectorAll('th').forEach(cell => {
        const key = cell.dataset.measureHeading;
        cell.textContent = copy[key] + (key === 'size' ? '' : ` (${unit})`);
      });
      [...tbody.rows].forEach((row, index) => {
        row.classList.toggle('fxg-size-guide__match', sizes[index] === matchedSize);
        row.querySelectorAll('[data-measure]').forEach(cell => cell.textContent = format(sizes[index][cell.dataset.measure]));
      });
    }

    function findSize() {
      matchedSize = null;
      result.hidden = false;
      result.replaceChildren();
      const value = input.valueAsNumber;
      const width = value / (unit === 'cm' ? 2.54 : 1);
      if (!Number.isFinite(value) || value <= 0) {
        input.setAttribute('aria-invalid', 'true');
        result.textContent = copy.invalid;
      } else {
        input.removeAttribute('aria-invalid');
        const sorted = [...sizes].sort((a, b) => a.width - b.width);
        if (width < sorted[0].width - 0.025 || width > sorted[sorted.length - 1].width + 0.025) {
          result.textContent = copy.outside;
        } else {
          matchedSize = sorted.find(size => size.width >= width - 0.025);
          const title = document.createElement('strong');
          title.textContent = copy.result.replace('{size}', matchedSize.size);
          const detail = document.createElement('p');
          detail.textContent = copy.result_detail;
          result.append(title, detail);
        }
      }
      renderTable();
    }

    guide.querySelector('[data-size-finder]').addEventListener('submit', event => {
      event.preventDefault();
      findSize();
    });
    input.addEventListener('input', () => {
      matchedSize = null;
      result.hidden = true;
      input.removeAttribute('aria-invalid');
      renderTable();
    });
    guide.querySelectorAll('[data-size-unit]').forEach(button => button.addEventListener('click', () => {
      const nextUnit = button.dataset.sizeUnit;
      if (nextUnit === unit) return;
      const currentValue = input.valueAsNumber;
      if (Number.isFinite(currentValue)) input.value = Number((currentValue * (nextUnit === 'cm' ? 2.54 : 1 / 2.54)).toFixed(4));
      unit = nextUnit;
      guide.querySelector('[data-input-unit]').textContent = unit;
      guide.querySelectorAll('[data-size-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (!result.hidden) findSize();
      else renderTable();
    }));
    renderTable();
  }

  window.FXGSizeGuide = { enhance };
})();
